/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

/**
 * @module bulb-progress/bulb-upload/bulbupload
 */

import { Plugin } from 'ckeditor5';
import BulbUploadProgress from './bulbuploadprogress';
import BulbUploadEditing from './bulbuploadediting';

export default class BulbUpload extends Plugin {

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbUpload' as const;
  }

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbUploadEditing, BulbUploadProgress] as const;
  }
}
